import { sanitizeValue } from '../../handlers/helpers/index';
import pixallEventValueTransformer from './pixallEventValueTransformer';
import pixallFilterNameTransformer from './pixallFilterNameTransformer';
const filterClickLabelTransformer = function (filterName, eventValue, updatedFilterTitle) {
  if (updatedFilterTitle === void 0) {
    updatedFilterTitle = '';
  }
  const scrubbedFilterName = filterName.includes('|') ? filterName.split('|')[0] : filterName;
  let labelValue = null;
  switch (scrubbedFilterName) {
    case 'startYear':
    case 'minPrice':
      {
        labelValue = `${pixallFilterNameTransformer(scrubbedFilterName)}::${eventValue}|max`;
        break;
      }
    case 'endYear':
    case 'maxPrice':
      {
        labelValue = `${pixallFilterNameTransformer(scrubbedFilterName)}::min|${eventValue}`;
        break;
      }
    case 'mileage':
      {
        if (eventValue === '200001') {
          labelValue = `${pixallFilterNameTransformer(scrubbedFilterName)}::over-200000`;
        } else {
          labelValue = `${pixallFilterNameTransformer(scrubbedFilterName)}::under-${eventValue}`;
        }
        break;
      }
    case 'fuelTypeGroup':
    case 'transmissionCode':
    case 'engineCode':
    case 'dealType':
    case 'sellerType':
      {
        labelValue = `${pixallFilterNameTransformer(scrubbedFilterName)}::${pixallEventValueTransformer(scrubbedFilterName, eventValue)}`;
        break;
      }
    case 'listingType':
    case 'driveGroup':
    case 'vehicleStyleCode':
    case 'mpgRange':
    case 'extColorSimple':
    case 'vehicleHistoryType':
    case 'homeServices':
    case 'intColorSimple':
    case 'makeCode':
    case 'modelCode':
    case 'doorCode':
    case 'trimCode':
    case 'seriesCode':
      {
        labelValue = `${pixallFilterNameTransformer(scrubbedFilterName)}::${sanitizeValue(eventValue)}`;
        break;
      }
    case 'marketExtension':
      {
        labelValue = `${pixallFilterNameTransformer(scrubbedFilterName)}::${sanitizeValue(updatedFilterTitle)}`;
        break;
      }
    default:
      break;
  }
  return labelValue;
};
export default filterClickLabelTransformer;